import { IBootstrapTableColumnProps } from 'react-bootstrap-table-next';
import { Currency } from 'ui-toolkit/components';
import { DateFormat, getDateString } from '../../../../../../ui-toolkit/utilities/getDateString';
import { IInternalTransferData } from '../../../../../../types/order/escrow/IInternalTransferData';
import { prettyInternalTransferCategory } from '../../../../../../types/accounting/response/eInternalTransferCategory';
import React from 'react';
import { convertColumnsToWrapBoldText } from '../../../../../../utilities/escrowPortal/convertColumnsToWrapText';
import { nbsp } from '../../../../../../utilities/administration/magicStrings';
import { FeeInformationColumn } from '../../FeeInformationColumn';

export const generateUnrestrictedInternalTransferTableColumns = (
  isZillowClosingEnabled: boolean,
): IBootstrapTableColumnProps<IInternalTransferData>[] =>
  convertColumnsToWrapBoldText<IInternalTransferData>([
      FeeInformationColumn,
      {
        text: 'Category',
        dataField: 'category',
        sort: true,
        formatter: (cell: any) => prettyInternalTransferCategory[cell],
      },
      {
        text: 'Memo',
        dataField: 'memo',
        sort: true,
      },
      {
        text: 'Amount',
        dataField: 'amountCents',
        sort: true,
        formatter: (cell: any, row?: IInternalTransferData) => {
          return row && <Currency value={cell} valueIsCents emptyContent={''} />;
        },
      },
      {
        text: 'Source Account',
        dataField: isZillowClosingEnabled ? 'sourceAccount.nickname' : 'sourceAccount.spruceNickname',
        sort: true,
      },
    {
      text: 'Destination Account',
      dataField: isZillowClosingEnabled ? 'destinationAccount.nickname' : 'destinationAccount.spruceNickname',
        sort: true,
      },
      {
        text: 'Wells Fargo Transaction Number',
        dataField: 'wellsFargoTransactionNumber',
        sort: true,
      },
      {
        text: 'Bank Reference',
        dataField: 'bankReference',
        sort: true,
      },
      {
        text: `Sent${nbsp}at`,
        dataField: 'sentAt',
        formatter: (cell: any) => getDateString(DateFormat.hugeDateTime, cell, true),
        sort: true,
      },
      {
        text: `Disbursed${nbsp}at`,
        dataField: 'disbursedAt',
        formatter: (cell: any) => getDateString(DateFormat.hugeDate, cell),
        sort: true,
      },
      {
        text: `Completed${nbsp}at`,
        dataField: 'completedAt',
        formatter: (cell: any) => getDateString(DateFormat.hugeDate, cell),
        sort: true,
      },
    ]);
